export default __webpack_public_path__ + "static/media/element_bg_web_wpp01.6e0a6229.svg";